export const trackStyles = {
  width: '150px',
  height: '6px',
  borderRadius: '6px',
  backgroundColor: 'background.default',
  overflow: 'hidden',
};

export const getFillStyles = percent => ({
  width: `${percent}%`,
  height: '100%',
  borderRadius: '6px',
  backgroundColor: 'success.main',
  transition: 'width 200ms ease',
});
